<div class="content__wrapper">
  <p-toast key="main"></p-toast>
  <p-confirmDialog key="main"></p-confirmDialog>
  @if (!isLoginPage) {
    <app-nav-menu
      [env]="environment"
      [userToken]="userToken"
      [firstName]="userLite?.firstName || ''"
      [lastName]="userLite?.lastName || ''"
      [isLoggedIn]="isLoggedIn"
      appTitle="Sierra Inventory"
      (logout)="onLogout()"
      [menuItems]="menuItems"
      [sites]="sites"
      [selectedSiteId]="selectedSiteId"
      (siteChanged)="onSiteChanged($event)"
    />
  }
  <div class="cs-shell">
    @if (!isLoginPage) {
      <csl-main-header />
    }
    <router-outlet></router-outlet>
  </div>
</div>
<csl-environment-indicator [envType]="environment" />
